import { Stack, styled } from '@mui/material';

export const StyledWhiteBox = styled(Stack)(({ theme }) => ({
  background: theme.palette.background.default,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(3),
}));
